import { setCollectionBreakdownModal } from "@actions/modals";
import collections from "@api/collections";
import { getControlValues } from "@helpers/summary";
import DataGrid from "@shared/DataGrid";
import React from "react";
import { connect } from "react-redux";
import { Grid } from "semantic-ui-react";

const Transactions = (props) => {
  const { collectionId, transactionsGrid, loading, transactionsSummaryGrid } =
    props.modal;

  const handleOptionChange = (option, value) => {
    const data = [...transactionsSummaryGrid.data];

    data.forEach((row, rowIndex) => {
      row.cellData.forEach((cell, cellIndex) => {
        if (cell.data.code === option.code) {
          data[rowIndex].cellData[cellIndex].data = option;
        }
      });
    });

    const grid = { ...transactionsSummaryGrid, data };
    props
      .setCollectionBreakdownModal(
        { loading: true },
        props.modal.onRefresh,
        props.modal.onClose,
      )
      .then(() => {
        props
          .setCollectionBreakdownModal(
            { transanctionSummaryGrid: grid },
            props.modal.onRefresh,
            props.modal.onClose,
          )
          .then(() => {
            collections
              .getBankingWeekTransactions(collectionId, getControlValues(data))
              .then((transactionsGrid) =>
                props.setCollectionBreakdownModal(
                  { loading: false, transactionsGrid },
                  props.modal.onRefresh,
                  props.modal.onClose,
                ),
              );
          });
      });
  };

  return (
    <Grid className="height-100 flex-container" padded="vertically">
      <Grid.Row>
        <Grid.Column width="16" classname="gs-flex-container-vertical">
          <DataGrid
            headings={transactionsSummaryGrid.headerDef}
            data={transactionsSummaryGrid.data}
            rowDef={transactionsSummaryGrid.rowDef}
            onOptionChange={handleOptionChange}
            hideOverflow
            disableActiveRow
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className="flex-stretch" style={{ paddingBottom: "0px" }}>
        <Grid.Column className="gs-flex-container-vertical">
          <DataGrid
            loading={loading}
            headings={transactionsGrid.headerDef}
            data={transactionsGrid.data}
            rowDef={transactionsGrid.rowDef}
            onRowClick={() => {}}
            fullHeight
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    modal: state.collectionBreakdownModal,
  };
};

export default connect(mapStateToProps, { setCollectionBreakdownModal })(
  Transactions,
);
